import { useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import BrandCard from './BrandCard';
import brands from '../data/brands.json';
import styles from './BrandsSection.module.css';

export default function BrandsSection() {
  const scrollRef = useRef(null);

  const scroll = (dir) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: dir * 340, behavior: 'smooth' });
    }
  };

  return (
    <section className={`${styles.section} section`} id="brands">
      <div className="container">
        <div className={styles.header}>
          <div>
            <p className="section-label">Our Partners</p>
            <h2 className="section-title">Brands We Represent</h2>
          </div>
          <div className={styles.scrollBtns}>
            <button className={styles.scrollBtn} onClick={() => scroll(-1)} aria-label="Scroll left">
              <ChevronLeft size={20} />
            </button>
            <button className={styles.scrollBtn} onClick={() => scroll(1)} aria-label="Scroll right">
              <ChevronRight size={20} />
            </button>
          </div>
        </div>
      </div>

      {/* Full-width scrollable row */}
      <div className={styles.trackWrap}>
        <div className={styles.track} ref={scrollRef}>
          {brands.map((brand) => (
            <BrandCard key={brand.id} brand={brand} />
          ))}
        </div>
      </div>
    </section>
  );
}
